import EmbedStep from '../../edit_steps/geobooster_widgets_embed'

export default {
  components: {
    EmbedStep
  }
}
